<template>
  <div class="modal fade" id="map-options-dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-white rounded-4">
        <div class="modal-header border-0 px-4 pt-3">
          <h5 class="modal-title"><strong>Options</strong></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-0">
          <ul class="list-group list-group-flush">
            <li v-if="showEditDetails" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('edit-details')">
              <span>Edit details</span>
              <span class="material-icons">edit</span>
            </li>
            <li v-if="editHike" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('edit')">
              <span>Open route in planner</span>
              <span class="material-icons">edit_location</span>
            </li>
            <li v-if="showCreate" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('create')">
              <span>Plan a hike</span>
              <span class="material-icons">add_location</span>
            </li>
            <li v-if="showWaypoints" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('waypoints')">
              <span>Waypoints</span>
              <span class="material-icons">add_location_alt</span>
            </li>
            <li v-if="showGoTo" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('goto')">
              <span>Go to location</span>
              <span class="material-icons">my_location</span>
            </li>
            <li v-if="showReportIssue" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('report-issue')">
              <span>Report an issue</span>
              <span class="material-icons">flag</span>
            </li>
          </ul>
          <div v-if="showMeasurement || showPrint" style="background: rgba(255,255,255,.04)">
            <div v-if="showMeasurement || showPrint" class="d-flex align-items-center mb-0 px-4 pt-3">
              <span class="badge bg-info text-dark me-2">PRO+</span>
            </div>
            <ul class="list-group list-group-flush">
              <li v-if="showMeasurement" class="list-group-item bg-transparent text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('measurement')">
                <span class="d-flex align-items-center"><span class="me-2 rounded-circle d-inline-block" style="width:8px;height:8px;background:#34c8ff"></span>Measurement tool</span>
                <span class="material-icons">straighten</span>
              </li>
              <li v-if="showPrint" class="list-group-item bg-transparent text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('print')">
                <span class="d-flex align-items-center"><span class="me-2 rounded-circle d-inline-block" style="width:8px;height:8px;background:#34c8ff"></span>Print hike map</span>
                <span class="material-icons">print</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>

<script setup>
import { Modal } from 'bootstrap'

// Define props to control which options are visible
const props = defineProps({
  showEditDetails: {
    type: Boolean,
    default: false
  },
  editHike: {
    type: Boolean,
    default: true
  },
  showCreate: {
    type: Boolean,
    default: true
  },
  showWaypoints: {
    type: Boolean,
    default: true
  },
  showGoTo: {
    type: Boolean,
    default: true
  },
  showMeasurement: {
    type: Boolean,
    default: true
  },
  showPrint: {
    type: Boolean,
    default: true
  },
  showReportIssue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['edit-details','edit','create','reverse','waypoints','goto','measurement','print','report-issue'])

function emitAndClose(evt){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).hide();
  emit(evt)
}

function open(){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).show();
}
defineExpose({ open })
</script>

<style scoped>

.list-group-item{
  border-bottom: 1px solid #434343;
  cursor: pointer;
}

.list-group-item:hover{
    opacity: 80%;
  }
</style>
